import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './news.action';
import { News } from '../../models/news.model';

export interface ErrorPayload {
  message: string;
  statusCode: number;
}

export interface NewsState {
  news: News[];
  loading: boolean;
  error: ErrorPayload | null;
}

export const initialState: NewsState = {
  news: [],
  loading: false,
  error: null,
};

export const newsReducer = createReducer(
  initialState,

  // When loading news products
  on(ProductActions.loadNews, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // On successful product load
  on(ProductActions.loadNewsSuccess, (state, { news }) => ({
    ...state,
    news,
    loading: false,
  })),

  // On failed product load
  on(ProductActions.loadNewsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
